import React, { useEffect } from "react";
//outsource
import { Select } from "antd";
//components
import lodash from "lodash";

const BranchSelect = (props) => {
  // -------------------------- VAR --------------------------
  const { branch, setBranch } = props;
  const { reportData } = props;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------
  const handleSelect = (value) => {
    setBranch(value);
  };
  const handleClear = () => {
    setBranch("");
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------

  const branchs = reportData?.map((data) => data.branch);
  const refineBranches = lodash.uniq(branchs);

  const options = [
    { label: "All", value: "" },
    ...(refineBranches?.map((branch) => {
      const option = {
        label: branch,
        value: branch,
      };
      return option;
    }) || []),
  ];

  return (
    <Select
      style={{ width: "100%" }}
      options={options}
      placeholder="Select Branch"
      allowClear
      showSearch
      defaultValue={""}
      value={branch ? branch : null}
      onSelect={(value) => handleSelect(value)}
      onClear={handleClear}
      filterOption={(input, option) =>
        option?.label?.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    />
  );
};

export default BranchSelect;
